import { ClientDetails } from "../___LOGIC/__interfaces/ClientDetails";

export const CLIENT_DETAILS_SEED: ClientDetails = {
    id: null,
    name: "ClienteTest",
    lastname: "García",
    lastname2: "Lopez",
    birthday: "1996-05-12",
    age: 29,
    goal: "Estudiar un máster en ensayos clínicos y trabajar en Europa",
    address: "Calle Muntaner 330, Barcelona, España",
    career: "Biomedicina",
    studyHistory: "finished",
    studySearch: "0",
    studyDescription: "Programa oficial orientado a CRO y farmacéuticas",
    studyType: "Oficial",
    studyConfirmation: "0",
    currentStudies: "Curso intensivo de inglés B2",
    present: "Residencia temporal en Barcelona",
    future: "Obtener empleo en industria farmacéutica",
    destination: "Madrid",
    university: "Universidad Autónoma de Madrid",
    payments: "Pendiente de matrícula",
    tuitionPaid: "1",
    driveUrl: "https://drive.google.com/example-folder",
    instagram: "@fio.garcia",
    phone1: "+34 600 123 456",
    phone2: "+506 8888 9999",
    how: "Instagram",
    apartmentFilters: "Cerca de universidad, máximo 30 min transporte",
    atEurope: "1",
    visitedCountries: "España, Francia, Alemania, Italia",
    additionalInterests: "Clases de yoga, voluntariado, intercambio cultural",
    hasStudentVisa: "Sí",
    usVisa: "1",
    uePassport: "0",
    validPassport: "1",
    imageUrl: "https://randomuser.me/api/portraits/women/44.jpg",
    dateFrom: "2025-09-01",
    dateTo: "2026-09-01",
    startLessons: "2025-09-15",
    firstContactDate: "2025-03-12",
    lastContactDate: "2025-08-30",
    comments: "Muy interesada en programas de prácticas con posibilidad de empleo.",
    country: "Costa Rica",
    apartmentType: "Compartido con estudiantes",
    apartmentBudget: "600 EUR/mes",
    apartmentBathroom: "Privado",
    stayWorking: "1",
    email: "fiorella.garcia@example.com"
};

export const EMPTY_CLIENT: ClientDetails = {
  id: null as any,          // cast needed since id is number
  name: null,
  lastname: null,
  lastname2: null,
  birthday: null,
  age: null,
  goal: null,
  address: null,
  career: null,
  studyHistory: null,
  studySearch: null,
  studyDescription: null,
  studyType: null,
  studyConfirmation: null,
  currentStudies: null,
  present: null,
  future: null,
  destination: null,
  university: null,
  payments: null,
  tuitionPaid: null,
  driveUrl: null,
  instagram: null,
  phone1: null,
  phone2: null,
  how: null,
  apartmentFilters: null,
  atEurope: null,
  visitedCountries: null,
  additionalInterests: null,
  hasStudentVisa: null,
  usVisa: null,
  uePassport: null,
  validPassport: null,
  imageUrl: null,
  dateFrom: null,
  dateTo: null,
  startLessons: null,
  firstContactDate: null,
  lastContactDate: null,
  comments: null,
  country: null,
  apartmentType: null,
  apartmentBudget: null,
  apartmentBathroom: null,
  stayWorking: null,
  email: null
};

